import ProviderAccountRegistrationDialog from './ProviderAccountRegistrationDialog';

export default ProviderAccountRegistrationDialog;
